<div class="esf-spinner flex-container-loading" *ngIf="loading">
  <div class="row">
    <span class="esf-spinner__bounce esf-spinner__bounce--1"></span>
    <span class="esf-spinner__bounce esf-spinner__bounce--2"></span>
    <span class="esf-spinner__bounce esf-spinner__bounce--3"></span>
  </div>
</div>
<main class="esf-main-content esf-main-content--has-sidebar -has-transition">
  <div class="esf-container" style="margin-left: calc(5vw); margin-right: calc(5vw);" *ngIf="!loading">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <div class="esf-action-heading__text">
        <span i18n='Page heading@@userListComponent.heading.users'>Users</span>
      </div>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">
          <span class="esf-tooltip esf-tooltip--top" i18n-data-tooltip='Tooltip@@general.tooltip.viewClubs' data-tooltip="View clubs">
            <button class="esf-button esf-button--filled esf-button--icon esf-button--icon-small" [routerLink]="['/manage/clubs']"
                    [disabled]="!(authenticatedUser.permissions.club.list)">
              <svg class="esf-icon" width="16" height="16">
                <use xlink:href="#esf-icon-club"></use>
              </svg>
            </button>
          </span>
        </span>
        <span class="esf-action-heading__action">
          <span class="esf-tooltip esf-tooltip--top" i18n-data-tooltip='Tooltip@@general.tooltip.createNewUser' data-tooltip="Create new user">
            <button class="esf-button esf-button--filled esf-button--icon esf-button--icon-small" (click)="userModalService.toggleModal(true)">
              <svg class="esf-icon" width="16" height="16">
                <use xlink:href="#esf-icon-plus"></use>
              </svg>
            </button>
          </span>
        </span>
      </span>
    </h1>

    <div class="esf-form-group">
      <div class="esf-form-item esf-form-item-1-2" *ngIf="authenticatedUser.isAdmin">
        <div class="esf-select">
          <select class="esf-form-item__field esf-select__field" [formControl]="$any(options.get('clubSelected'))" (change)="updateClubSelection()">
            <option i18n="Form label@@general.formLabel.allClubs" value="allClubs">All clubs</option>
            <option *ngFor="let club of listOfClubs" [value]="club.id">{{ club.name }}</option>
          </select>
        </div>
      </div>
      <div class="esf-form-item-1-2"
           app-form-field-search
           [placeholder]="flTranslations.i18nSearchUser"
           [id]="'search'"
           [control]="options.get('orSearchAll')"
           (inputChanged)="triggerSearch()">
      </div>
    </div>

    <app-paginated-table [columns]="columns"
                         [keys]="keys"
                         [data]="data"

                         [baseApi]="baseApi"
                         [customQueries]="customQueries"
                         (dataFetchedEmitter)="showUserList($event)"

                         (rowClickEvent)="routerLink($event)"

                         [emptyStateIcon]="'#esf-icon-bell-32'">
    </app-paginated-table>
  </div>
</main>

<app-create-user [listOfClubs]="listOfClubs" *ngIf="userModalService.modalOpened"></app-create-user>
